var _g, _g2, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 140,
    viewBox: "0 0 200 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2394_146086)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.068 62.0013C155.688 58.7195 151.277 56.1723 145.592 55.3757L93.3759 48.0595C87.9695 47.302 82.2269 48.2441 78.2478 50.5414L33.4823 76.3868C27.2257 79.9991 27.1477 85.8097 33.3071 89.3659L98.195 126.829C104.355 130.385 114.419 130.34 120.675 126.728L165.441 100.882C169.42 98.5851 171.052 95.2696 169.74 92.1483L157.068 62.0013ZM94.0283 70.3712C93.6308 69.0116 91.394 68.1131 89.0331 68.3639C86.6721 68.6146 85.0803 69.9201 85.4781 71.2795L91.3384 91.3104C91.6408 92.345 93.0351 93.15 94.827 93.3245L129.522 96.708C131.876 96.9376 134.137 96.0187 134.571 94.6555C135.006 93.2925 133.449 92.0009 131.095 91.7715L99.3846 88.6791L94.0283 70.3712Z",
    fill: "#FFF6EA"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2394_146086)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.068 48.3607C155.688 45.0789 151.277 42.5316 145.592 41.7351L93.3759 34.4189C87.9695 33.6614 82.2269 34.6035 78.2478 36.9008L33.4823 62.7462C27.2257 66.3585 27.1477 72.1691 33.3071 75.7252L98.195 113.188C104.355 116.744 114.419 116.699 120.675 113.087L165.441 87.2418C169.42 84.9445 171.052 81.629 169.74 78.5077L157.068 48.3607ZM94.0283 56.7306C93.6308 55.371 91.394 54.4725 89.0331 54.7232C86.6721 54.974 85.0803 56.2795 85.4781 57.6389L91.3384 77.6698C91.6408 78.7043 93.0351 79.5093 94.827 79.6839L129.522 83.0674C131.876 83.297 134.137 82.3781 134.571 81.0149C135.006 79.6518 133.449 78.3603 131.095 78.1309L99.3846 75.0384L94.0283 56.7306Z",
    fill: "#FEECD5"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2394_146086)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.068 34.7123C155.688 31.4304 151.277 28.8832 145.592 28.0866L93.3759 20.7704C87.9695 20.013 82.2269 20.9551 78.2478 23.2524L33.4823 49.0978C27.2257 52.71 27.1477 58.5207 33.3071 62.0768L98.195 99.5399C104.355 103.096 114.419 103.051 120.675 99.4387L165.441 73.5933C169.42 71.296 171.052 67.9806 169.74 64.8592L157.068 34.7123ZM94.0283 43.0822C93.6308 41.7226 91.394 40.824 89.0331 41.0748C86.6721 41.3255 85.0803 42.6311 85.4781 43.9904L91.3384 64.0214C91.6408 65.0559 93.0351 65.8609 94.827 66.0355L129.522 69.4189C131.876 69.6486 134.137 68.7297 134.571 67.3664C135.006 66.0034 133.449 64.7119 131.095 64.4825L99.3846 61.39L94.0283 43.0822Z",
    fill: "#FDD9AA"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_2394_146086)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.068 21.0716C155.688 17.7898 151.277 15.2426 145.592 14.446L93.3759 7.1298C87.9695 6.37233 82.2269 7.31445 78.2478 9.61176L33.4823 35.4571C27.2257 39.0694 27.1477 44.8801 33.3071 48.4362L98.195 85.8992C104.355 89.4554 114.419 89.4104 120.675 85.7981L165.441 59.9527C169.42 57.6554 171.052 54.3399 169.74 51.2186L157.068 21.0716ZM94.0283 29.4416C93.6308 28.082 91.394 27.1834 89.0331 27.4342C86.6721 27.6849 85.0803 28.9905 85.4781 30.3498L91.3384 50.3807C91.6408 51.4153 93.0351 52.2203 94.827 52.3949L129.522 55.7783C131.876 56.0079 134.137 55.0891 134.571 53.7258C135.006 52.3628 133.449 51.0712 131.095 50.8419L99.3846 47.7494L94.0283 29.4416Z",
    fill: "#FBA12B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2394_146086"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 124.443,
    height: 124.443,
    fill: "white",
    transform: "matrix(0.866025 0.5 -0.866025 0.5 103.77 20.9297)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2394_146086"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 124.443,
    height: 124.443,
    fill: "white",
    transform: "matrix(0.866025 0.5 -0.866025 0.5 103.77 7.28906)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2394_146086"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 124.443,
    height: 124.443,
    fill: "white",
    transform: "matrix(0.866025 0.5 -0.866025 0.5 103.77 -6.35938)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_2394_146086"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 124.443,
    height: 124.443,
    fill: "white",
    transform: "matrix(0.866025 0.5 -0.866025 0.5 103.77 -20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.f908ed68a3fd27e486e936acf2bf06af.svg";
export { ForwardRef as ReactComponent };